<template>
  <div id="app">
    <template v-if="isLoggedIn">
      <dashboard></dashboard>
    </template>
    <template v-else>
      <login></login>
    </template>
  </div>
</template>

<script>
import Dashboard from '@/components/app/AppDashboard'
import Login from '@/components/routes/Login'

export default {
  name: 'app',
  components: {
    'login': Login,
    'dashboard': Dashboard
  },
  data: function () {
    return {
      sidebarOpen: false
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters['wordpress/account/isLoggedIn']
    }
  },
  methods: {
  },
  created: function () {
    if (process.env.NODE_ENV !== 'production') console.log('App.vue created')
  }
}
</script>

<style lang="scss">
@import '~scss/variables';
@import '~scss/layout';
@import '~scss/theme';
@import '~scss/GitHubMarkdown';

body {
  color: #666 !important;
  font-family: Quicksand, san-serif !important;
  font-size: 14px !important;
}

#app {
  color: #333 !important;
}

.app {
  &-section {
    border-top: 4px solid #569cf3;
  }
  &-header {
    padding: 3em 2em 2em;
    @media (min-width: breakpoint('l')) {
      padding: 2em;
    }
    border-bottom: 1px solid #d9d9cf;
  }
  &-h2 {
    margin: 0;
  }
}

.GitHubMarkdown {
  & h3 {
    margin-top: 2em !important;
    border-bottom: 1px solid #ccc !important;
    padding-bottom: .5em;
  }
}

.el-input {
  width: auto;
  &.width-100 {width: 100%}
  &.width-75 {width: 75%}
  &.width-50 {width: 50%}
}

.el-dialog.el-dialog--full {
  background: rgba(255,255,255,.95);
}

.el-carousel {
  &__contents {
    padding: 1em;
    height: 100%;
  }
  &__item {
    & h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      margin: 0;
    }
    &:nth-child(2n) {
      background-color: #99a9bf;
    }
    &:nth-child(2n+1) {
      background-color: #d3dce6;
    }
  }
}


.fab {
  &.pointer,
  &.pointer > .material-icons {
    user-select: none !important;
  }
  &-list {
    .pointer {
      & > .material-icons {
        width: 18px;
        text-align: center;
        line-height: 1;
      }
    }
  }
}

.site-preview {
  margin: 0 auto;
  max-width: 1280px;
  background-color: #fff;
  &-wrapper {
    background-color: #f3f3f3;
  }
}


.el-dialog {
  &--tiny {
    width: 90% !important;
    max-width: 400px !important;
  }
  &--small {
    width: 98% !important;
    max-width: 500px !important;
  }
}

.component-warning {
  padding: 5em 2em;
  background-color: #fafafa;
  border: 1px solid #ddd;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' style='fill:transparent; stroke:#ddd' %3E%3Cpath d='M100,0 L0,100 Z' /%3E%3C/svg%3E");
  background-repeat: repeat;
  &-span {
    color: red;
  }
}

.width-100 {width: 100%}
.width-75 {width: 75%}
.width-50 {width: 50%}

.el-input {
  width: auto;
}

.image-info {
  margin: 1em 0;
  width: 100%;
  height: 220px;
  background-color: $--color-extra-light-gray;
  &-size {
    margin: 0;
  }
  &-img {
    width: 100%;
    height: 200px;
    object-fit: contain;
  }
}

.component-contents {
  &-form {
    margin: 1em auto;
    border: 1px solid $--color-primary;
    border-radius: 8px;
    width: 90%;
    background-color: $--color-primary-extra-light;
    &.show {
      display: block;
    }
    &.hide {
      display: none;
    }
  }
  &-controller {
    margin: 1em 0;
  }
}

.preview {
  position: relative;
  overflow: hidden;
  background-color: #fff;
  &-wrapper {
    background-color: #bbc2cc;
  }
  &.smartphone {
    margin: 0 auto;
    width: 320px;
  }
  &.tablet {
    margin: 0 auto;
    width: 768px;
  }
}

.centering .el-dialog {
  margin: auto !important;
  position: absolute;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%,-50%) !important;
}


// メッセージボックスの文字列内で\nで改行する
.el-message-box__message p {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue